<template>
    <component
        :is="$auth.isSubdomainActive() ? 'div' : 'common-content-spacer'"
        :height="$auth.isSubdomainActive() ? '' : 'small'"
    >
        <div v-if="heading || breadcrumbs" class="main-layout__heading">
            <common-content-spacer v-if="!$auth.isSubdomainActive()" height="small">
                <common-breadcrumbs v-if="breadcrumbs" :breadcrumbs="breadcrumbs"></common-breadcrumbs>

                <common-page-header v-if="heading" :heading="heading"></common-page-header>
            </common-content-spacer>

            <slot name="right-side"></slot>
        </div>

        <slot name="content"></slot>
    </component>
</template>

<script>
    export default {
        props: {
            breadcrumbs: { type: Object, default: undefined },
            heading: { type: String, default: undefined },
        },
    }
</script>
